<template>
  <!-- <div class="login-box home">
    <BlockUI v-show="loadingStatus">
      <img src="@/assets/loading_1.svg" />
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="login-logo">
      <a href="../../index2.html">
        <b>ورود به سایت</b>
      </a>
    </div>
    <div class="card" v-if="formView.AuthType=='Tradition'">
      <div class="card-body login-card-body">
        <p class="login-box-msg">فرم زیر را تکمیل کنید و ورود بزنید</p>
        <form @submit.prevent="authTradition">
          <div class="input-group mb-3">
            <input
              type="email"
              class="form-control text-left"
              placeholder="ایمیل"
              v-model="user.UserName"
              required
            />
            <div class="input-group-append">
              <span class="fa fa-envelope input-group-text"></span>
            </div>
          </div>
          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control text-left"
              placeholder="رمز عبور"
              v-model="user.Password"
              required
            />
            <div class="input-group-append">
              <span class="fa fa-lock input-group-text"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <button type="submit" class="btn btn-primary btn-block btn-flat">ورود</button>
            </div>

          </div>
        </form>
        <p class="mb-1 mt-2">
          <a href="#">رمز عبورم را فراموش کرده ام.</a>
        </p>
        <p class="mb-0">
          <a href="register.html" class="text-center">ثبت نام</a>
        </p>
      </div>
    </div>
    <div class="card" v-if="formView.AuthType=='Sms'">
      <div class="card-body login-card-body" v-if="formView.SmsForm=='Step_1'">
        <p class="login-box-msg">شماره همراه را وارد نمایید و ورود بزنید</p>
        <form @submit.prevent="authSms">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control text-left"
              placeholder="شماره همراه"
              v-model="user.Mobile"
              required
            />
            <div class="input-group-append">
              <span class="fa fa-envelope input-group-text"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <button
                type="submit"
                class="btn btn-primary btn-block btn-flat"
                id="btn_SendSmsCode"
                :disabled="btn_SendSmsCode.Status"
              >{{btn_SendSmsCode.Text}}</button>
            </div>
          </div>
        </form>
        <p class="mb-0 text-left">
          <a href="register.html" class="text-center">ثبت نام</a>
        </p>
      </div>
      <div class="card-body login-card-body" v-if="formView.SmsForm=='Step_2'">
        <p class="login-box-msg">کدپیامک شده را وارد نمایید و ورود بزنید</p>
        <form @submit.prevent="verifySmsCode()">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control text-left"
              placeholder="کد ورود"
              v-model="user.SmsCode"
              required
            />
            <div class="input-group-append">
              <span class="fa fa-envelope input-group-text"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <button
                type="submit"
                class="btn btn-primary btn-block btn-flat"
                :disabled="btn_VerifySmsCode.Status"
              >{{btn_VerifySmsCode.Text}}</button>
            </div>
          </div>
        </form>
        <p class="mb-0 text-left">
          <a
            href="#"
            class="text-center"
            @click="formView.SmsForm='Step_1'"
          >شماره همراه را اشتباه وارد کردم</a>
        </p>
      </div>
    </div>
    <div class="modal fade" id="modal_LoginMessage">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-header bg-danger text-center p-2">
            <h6 class="modal-title">پیغام سیستم</h6>
          </div>
          <div class="modal-body text-center">{{message}}</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger btn-block" data-dismiss="modal">بستن</button>
          </div>
        </div>
      </div>
    </div>
  </div>-->
  <div class="authentication">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="container">
      <div class="row justify-content-center" v-if="formView.AuthType=='Tradition'">
        <div class="col-lg-4 col-sm-12">
          <form class="card auth_form" @submit.prevent="authTradition">
            <div class="header">
<!--              <img class="logo" src="assets/images/BehranMotorLogo.png" style="height: 80px;width: 150px;"/>-->
              <h5>خورشید شب</h5>
            </div>
            <div class="body">
              <div class="input-group mb-3">
                <input
                    type="text"
                    class="form-control text-left"
                    placeholder="نام کاربری"
                    v-model="user.UserName"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="zmdi zmdi-account-circle"></i>
                  </span>
                </div>
              </div>
              <div class="input-group mb-3">
                <input
                    type="password"
                    class="form-control text-left"
                    placeholder="رمزعبور"
                    v-model="user.Password"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <!-- <a href="forgot-password.html" class="forgot" title="فراموشی رمز عبور"> -->
                    <i class="zmdi zmdi-lock"></i>
                    <!-- </a> -->
                  </span>
                </div>
              </div>
              <!-- <div class="checkbox">
                <input id="remember_me" type="checkbox" />
                <label for="remember_me">مرا به خاطر بسپار</label>
              </div>-->
              <button type="submit" class="btn btn-primary btn-block waves-effect waves-light">ورود
              </button>
              <!--                            <a href="#" class="btn btn-link mt-2">فراموشی رمز عبور</a>-->
              <!-- <div class="signin_with mt-3">
                <p class="mb-0">یا ثبت نام با استفاده از</p>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round facebook">
                  <i class="zmdi zmdi-facebook"></i>
                </button>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round twitter">
                  <i class="zmdi zmdi-twitter"></i>
                </button>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round google">
                  <i class="zmdi zmdi-google-plus"></i>
                </button>
              </div>-->
            </div>
          </form>
          <!-- <div class="copyright text-center">
             <span>
               طراحی و توسعه توسط
               <a href="#" target="_blank">گروه نرم افزاری و آموزشی نارون</a>
             </span>
           </div>-->
        </div>
        <!-- <div class="col-lg-8 col-sm-12">
          <div class="card">
            <img src="assets/images/signin.svg" alt="Sign In" />
          </div>
        </div>-->
      </div>

      <div class="row justify-content-center" v-if="formView.AuthType=='Sms'">
        <div class="col-lg-4 col-sm-12">
          <form @submit.prevent="authSms" class="card auth_form" v-if="formView.SmsForm=='Step_1'">
            <div class="header">
              <img class="logo" src="assets/images/logo.svg" alt/>
              <h5>ورود</h5>
            </div>
            <div class="body">
              <div class="input-group mb-3">
                <input type="number" class="form-control text-left" placeholder="شماره همراه"
                       v-model="user.Mobile" pattern="[0-9]{11,11}" maxlength="11"/>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="zmdi zmdi-smartphone-android"></i>
                  </span>
                </div>
              </div>

              <!-- <div class="checkbox">
                <input id="remember_me" type="checkbox" />
                <label for="remember_me">مرا به خاطر بسپار</label>
              </div>-->
              <!-- <a href="index.html" class="btn btn-primary btn-block waves-effect waves-light">ورود</a> -->
              <button
                  type="submit"
                  class="btn btn-primary btn-block waves-effect waves-light"
                  id="btn_SendSmsCode"
                  :disabled="btn_SendSmsCode.Status"
              >{{ btn_SendSmsCode.Text }}
              </button>
              <!-- <div class="signin_with mt-3">
                <p class="mb-0">یا ثبت نام با استفاده از</p>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round facebook">
                  <i class="zmdi zmdi-facebook"></i>
                </button>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round twitter">
                  <i class="zmdi zmdi-twitter"></i>
                </button>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round google">
                  <i class="zmdi zmdi-google-plus"></i>
                </button>
              </div>-->
            </div>
          </form>
          <form
              class="card auth_form"
              @submit.prevent="verifySmsCode()"
              v-if="formView.SmsForm=='Step_2'"
          >
            <div class="header">
              <img class="logo" src="assets/images/logo.svg" alt/>
              <h5>ورود</h5>
            </div>
            <div class="body">
              <div class="input-group mb-3">
                <input type="number" class="form-control text-left" placeholder="کد ورود"
                       v-model="user.SmsCode" maxlength="4"/>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="zmdi zmdi-zero"></i>
                  </span>
                </div>
              </div>

              <!-- <div class="checkbox">
                <input id="remember_me" type="checkbox" />
                <label for="remember_me">مرا به خاطر بسپار</label>
              </div>-->
              <!-- <a href="index.html" class="btn btn-primary btn-block waves-effect waves-light">ورود</a> -->
              <button
                  type="submit"
                  class="btn btn-primary btn-block btn-flat"
                  :disabled="btn_VerifySmsCode.Status"
              >{{ btn_VerifySmsCode.Text }}
              </button>
              <!-- <div class="signin_with mt-3">
                <p class="mb-0">یا ثبت نام با استفاده از</p>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round facebook">
                  <i class="zmdi zmdi-facebook"></i>
                </button>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round twitter">
                  <i class="zmdi zmdi-twitter"></i>
                </button>
                <button class="btn btn-primary btn-icon btn-icon-mini btn-round google">
                  <i class="zmdi zmdi-google-plus"></i>
                </button>
              </div>-->
            </div>
          </form>
          <div class="copyright text-center">
            <span class="text-white">
              طراحی و توسعه توسط
              <a
                  href="#"
                  target="_blank"
                  class="text-white"
              >گروه نرم افزاری و آموزشی هاوین وب</a>
            </span>
          </div>
        </div>
        <!-- <div class="col-lg-8 col-sm-12">
          <div class="card">
            <img src="assets/images/signin.svg" alt="Sign In" />
          </div>
        </div>-->
      </div>
    </div>
    <div class="modal fade" id="modal_LoginMessage">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-header bg-danger text-center p-2">
            <h6 class="modal-title text-white">پیغام سیستم</h6>
          </div>
          <div class="modal-body text-center">{{ message }}</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger btn-block" data-dismiss="modal">بستن</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      user: {UserName: "", Password: "", Mobile: "", SmsCode: ""},
      loadingStatus: false,
      message: "",
      formView: {AuthType: "", SmsForm: "Step_1"},
      btn_SendSmsCode: {Status: false, Text: "مرحله بعد"},
      btn_VerifySmsCode: {Status: false, Text: "ورود"},
      loadingShow:false
    };
  },
  created() {
    this.getLoginType();
  },
  methods: {
    authTradition() {
      let self = this;
      //console.log("test");

      if (self.user.UserName === "" || self.user.Password === "") {
        self.message = "پر کردن فیلد های ایمیل و رمز عبور الزامی می باشد";
        $("#modal_LoginMessage").modal("show");
        return;
      }
      self.loadingShow = true;
      let formData = {
        UserName: self.user.UserName,
        Password: self.user.Password
      };
      axios
          .post("https://araksolar.ir/webhook/user-login", formData)
          .then(function (res) {
            const {Data, Message, Status} = res.data[0];
            // console.log(response.data);
            if (Status === 1) {


              localStorage.setItem(
                  "UserInfo",
                  JSON.stringify({
                    Token: `${Data.Token}`,
                    // Roles: `${response.data.Data.Roles}`
                  })
              );
              self.loadingShow = false;
              self.$router.push("/userpanel");
            } else {
              self.loadingShow = false;
              self.message = Message;
              $("#modal_LoginMessage").modal("show");
            }
            //console.log(response.data);
          })
          .catch(function (error) {
            self.loadingShow = false;
            self.message = "خطایی نا مشخص رخ داده است،دوباره تلاش نمایید";
            $("#modal_LoginMessage").modal("show");

          }).finally(function () {
      });

    },
    authSms() {
      var self = this;
      // self.formView.SmsForm = "Step_2";
      if (self.user.Mobile === "") {
        self.message = "شماره همراه را وارد کنید";
        $("#modal_LoginMessage").modal("show");
        return;
      }
      self.btn_SendSmsCode = {Status: true, Text: "شکیباباشید..."};
      let formData = {
        Mobile: self.user.Mobile
      };
      axios
          .post("/SendAdminAuthSmsCode", formData)
          .then(function (response) {
            if (response.data.Status === 1) {
              self.formView.SmsForm = "Step_2";
            } else {
              self.message = response.data.Message;
              $("#modal_LoginMessage").modal("show");
            }
          })
          .catch(function (error) {
            self.message = "خطایی نا مشخص رخ داده است،دوباره تلاش نمایید";
            $("#modal_LoginMessage").modal("show");
          })
          .finally(function () {
            self.btn_SendSmsCode = {Status: false, Text: "مرحله بعد"};
          });
    },
    verifySmsCode() {
      let self = this;
      // self.$router.push("/userpanel");
      if (self.user.SmsCode === "") {
        self.message = "کد ورود را وارد نمایید";
        $("#modal_LoginMessage").modal("show");
        return;
      }
      //self.loadingStatus = true;
      self.btn_VerifySmsCode = {Status: true, Text: "شکیباباشید..."};
      let formData = {
        Mobile: self.user.Mobile,
        SmsCode: self.user.SmsCode
      };
      axios
          .post("/VerifyAdminSmsCode", formData)
          .then(function (response) {
            console.log("Verify SMS Code", response.data);
            if (response.data.Status === 1) {
              localStorage.setItem(
                  "UserInfo",
                  JSON.stringify({
                    Token: `${response.data.Data.Token}`,
                    Roles: `${response.data.Data.Roles}`
                  })
              );
              self.$router.replace("/userpanel");
            } else {
              self.message = response.data.Message;
              $("#modal_LoginMessage").modal("show");
            }
          })
          .catch(function (error) {
            self.message = "خطایی نا مشخص رخ داده است،دوباره تلاش نمایید";
            $("#modal_LoginMessage").modal("show");
          })
          .finally(function () {
            self.btn_VerifySmsCode = {Status: false, Text: "ورود"};
          });
    },
    getLoginType() {
      let self = this;
      // if (localStorage.getItem("UserInfo") === null) {
      //   self.$router.push("/login");
      //   return;
      // }
      //var userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      /*axios
          .get("/GetAuthType")
          .then(function (response) {
              self.formView.AuthType = response.data.Data;
          })
          .catch(function (error) {
              //console.log(error);
          });*/
      self.formView.AuthType = "Tradition"
    }
  },
  beforeCreate: function () {
    document.body.className = "theme-blush login-bg";
    /*var link1 = document.createElement("link");
    link1.rel = "stylesheet";
    link1.href = require("../../public/assets/plugins/bootstrap/css/bootstrap.min.css");
    document.head.appendChild(link1);

    var link2 = document.createElement("link");
    link2.rel = "stylesheet";
    link2.href = require("../../public/assets/plugins/jquery-datatable/dataTables.bootstrap4.min.css");
    document.head.appendChild(link2);

    var link3 = document.createElement("link");
    link3.rel = "stylesheet";
    link3.href = require("../../public/assets/css/style.min.css");
    document.head.appendChild(link3);*/
  }
};
</script>
<style>
htm,body,.authentication{
  height: 100%;
}
::-webkit-input-placeholder {
  text-align: right;
}

input:-moz-placeholder {
  text-align: right;
}
</style>
